import { render, staticRenderFns } from "./LotteryConfig.vue?vue&type=template&id=386ef552&"
import script from "./LotteryConfig.vue?vue&type=script&lang=js&"
export * from "./LotteryConfig.vue?vue&type=script&lang=js&"
import style0 from "./LotteryConfig.vue?vue&type=style&index=0&id=386ef552&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports